import { render } from "./SingleProject.vue?vue&type=template&id=b4e08c84"
import script from "./SingleProject.vue?vue&type=script&lang=js"
export * from "./SingleProject.vue?vue&type=script&lang=js"

import "./SingleProject.vue?vue&type=style&index=0&id=b4e08c84&lang=css"

import exportComponent from "/Users/meganma/Documents/Web Projects/meganm38.github.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__